import React, { useEffect } from "react";
import styled from "styled-components";
import { FlexBox, ImgWrap } from "../../styles/Common";
import arrow from "../../styles/images/ico_arrow_down.svg";
import icoAnswer from "../../styles/images/ico_answer.svg";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../store/slices/userSlice";
import { getToken } from "../hooks/authFunc";
import { returnInquireCategory, timeChange } from "../hooks/basicFunc";
import NoHistory from "./NoHistory";

const InquiryList = (props) => {
  const dispatch = useDispatch();
  const accessToken = getToken();
  const data = useSelector((state) => state.user.inquiryList);
  const getData = () => {
    const params = {
      page: 1,
      pageSize: 10,
    };
    dispatch(userActions.fetchInquiryList({ params, accessToken }));
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <InquiryListWrap>
      <ul>
        {data.count > 0 ? (
          data.list.map((li, index) => (
            <li key={index} className="pointer">
              <details
              // open={li.answers.length == 0 ? true : false}
              // disabled={li.answers.length == 0 ? true : false}
              >
                <summary>
                  <StatusDiv>
                    <p>[{returnInquireCategory(li.category)}]</p>
                    <Status
                      className={li.answers.length == 0 ? "notAnswer" : ""}
                    >
                      {li.answers.length == 0 ? "대기" : "완료"}
                    </Status>
                  </StatusDiv>
                  <TitleDiv>
                    <div>
                      <h4>{li.title}</h4>
                      <p>{timeChange(li.time)}</p>
                    </div>
                    <img src={arrow} alt="arrow" />
                  </TitleDiv>
                </summary>
                <OepenDiv>
                  <p>{li.content}</p>
                  {li.reply > 0 &&
                    li.answers.map((li, i) => (
                      <Answer>
                        <img src={icoAnswer} alt="arrow" />
                        <p>{li.content}</p>
                      </Answer>
                    ))}
                </OepenDiv>
              </details>
            </li>
          ))
        ) : (
          <NoHistory />
        )}
      </ul>
    </InquiryListWrap>
  );
};

export default InquiryList;
const InquiryListWrap = styled.div`
  li {
    border-radius: 1rem;
    padding: 2rem 1.5rem;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
    background-color: ${({ theme }) => theme.color.white};
    margin-top: 1rem;
    &:nth-of-type(1) {
      margin-top: 0;
    }
  }

  details[open] {
    summary {
      padding-bottom: 2rem;
      img {
        transform: rotate(180deg);
      }
    }
  }
  details[disabled] {
    summary {
      pointer-events: none; /* prevents click events */
      user-select: none; /* prevents text selection */
    }
  }
`;
const StatusDiv = styled(FlexBox)`
  justify-content: space-between;
  align-items: flex-start;
  p {
    color: #ad7aff;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px; /* 133.333% */
  }
`;
const TitleDiv = styled(FlexBox)`
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 0.2rem;
  h4 {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2rem; /* 100% */
  }
  p {
    font-size: 1rem;
    line-height: 1rem; /* 100% */
    margin-top: 1rem;
  }
`;
const Status = styled.div`
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.color.purple_second};
  width: 5.2rem;
  height: 2.4rem;
  color: ${({ theme }) => theme.color.white};
  font-size: 1rem;
  text-align: center;
  line-height: 2.4rem;
  &.notAnswer {
    background-color: ${({ theme }) => theme.color.input_text_gray_light};
  }
`;
const OepenDiv = styled.div`
  border-top: 1px dashed #000;
  padding-top: 2rem;
  p {
    font-size: 1.2rem;
    line-height: 1.4rem; /* 100% */
  }
`;
const Answer = styled.div`
  margin-top: 3rem;
  display: flex;
  img {
    margin-right: 1.5rem;
    width: 3.2rem;
    height: 2.7rem;
  }
`;
